import PropTypes from 'prop-types';
import { ENTER_DELAY } from 'sagas';
import { Button, Tooltip } from '@material-ui/core';
import { withPayerNotesAccess } from 'components/common/permissions';

const AddNote = ({ onAdd }) => (
  <Tooltip
    enterDelay={ENTER_DELAY}
    title="Internal Note Only. A notification will not be sent to Payrailz Support."
  >
    <Button aria-label="Add Note" onClick={onAdd} variant="outlined">
      Notes
    </Button>
  </Tooltip>
);

AddNote.propTypes = {
  onAdd: PropTypes.func.isRequired,
};

export default withPayerNotesAccess(AddNote);
